/**
 * Fix para el bug de React con Google Translate
 *
 * Problema:
 *   Google Translate reemplaza nodos de texto del DOM. Cuando React intenta
 *   actualizar/remover estos nodos, lanza NotFoundError porque los nodos
 *   originales ya no son hijos del padre esperado. Esto crashea toda la app.
 *
 * Solucion:
 *   Monkey-patch de Node.prototype.removeChild e insertBefore para que en caso
 *   de NotFoundError simplemente retornen silenciosamente en vez de crashear.
 *
 * Basado en la solucion oficial de React:
 *   https://github.com/facebook/react/issues/11538#issuecomment-417504600
 */

if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
        if (child.parentNode !== this) {
            if (console && typeof console.warn === 'function') {
                console.warn(
                    'Cannot remove a child from a different parent',
                    child,
                    this
                );
            }
            return child;
        }
        return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            if (console && typeof console.warn === 'function') {
                console.warn(
                    'Cannot insert before a reference node from a different parent',
                    referenceNode,
                    this
                );
            }
            return newNode;
        }
        return originalInsertBefore.apply(this, arguments);
    };
}

export default {};
